import { useEffect } from "react";

export const useWindowEvent = (event, callback) => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener(event, callback);

      return () => window.removeEventListener(event, callback);
    }
  }, [event, callback]);
};

export const GlobalYScrollListener = ({ yThreshold = 80, setter }) => {
  return useWindowEvent("scroll", () => {
    if (window.scrollY > yThreshold) {
      setter(true);
    } else {
      setter(false);
    }
  });
};
